// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","513":"35647740","665":"68e4b565","706":"cc727622","769":"5aea8a44"}[chunkId] + ".chunk.js";
};